import * as d3 from "d3";
import {
    axisTextDim1,
    colonAnnotation, contextMenu,
    createTooltip,
    DEFAULT_AXIS_FONT_SIZE,
    DEFAULT_AXIS_LABEL_FONT_SIZE,
    generateDownloadData,
    numberFormat,
    responsivefy
} from '../functions'

export default function (chart,divId,vizName,resData, filterParam,checkbox, gridflag, showValuesFlag){
    console.log(vizName)
    console.log(filterParam)

    const defaultSize = true
    const defaultChartLayout = {
        width: 1000,
        height: 600,
        margin: { top: 30, right: 50, bottom: 180, left: 100 }
    }
    const chartWidth = defaultSize ? defaultChartLayout.width : chart.width
    const chartHeight = defaultSize ? defaultChartLayout.height : chart.height
    const chartMargin = defaultSize ? defaultChartLayout.margin : chart.margin

// set the dimensions and margins of the graph
    var margin = chartMargin,
        width = chartWidth - margin.left - margin.right,
        height = chartHeight - margin.top - margin.bottom;

    var svg = d3.select(divId)
    svg.selectAll("*").remove();

// append the svg object to the body of the page
    svg = d3.select(divId)
        .append("svg")
        .attr("width", chartWidth + chartMargin.left + chartMargin.right)
        .attr("height", chartHeight + chartMargin.top + chartMargin.bottom)
        .call(responsivefy)
        .append("g")
        .attr("transform",
            "translate(" + margin.left + "," + margin.top + ")");



        let data = resData
        var fontsize = (defaultSize ? DEFAULT_AXIS_FONT_SIZE : chart.axisFontSize) + 'px';
        var fontlablesize = (defaultSize ? DEFAULT_AXIS_LABEL_FONT_SIZE : chart.axisLabelFontSize) + 'px';
        var result = data.reduce((x, y) => {

            (x[y.dim1_name] = x[y.dim1_name] || []).push(y);

            return x;

        }, {});



        var wide = d3.nest()
            .key(function (d) {
                return d["dim1_name"]
            }) // sort by key
            .rollup(function (d) { // do this to each grouping
                // reduce takes a list and returns one value
                // in this case, the list is all the grouped elements
                // and the final value is an object with keys
                return d.reduce(function (prev, curr) {
                    prev["dim1_name"] = curr["dim1_name"];
                    prev[curr["dim2_name"]] = curr["metric1"];
                    console.log("prev", prev)
                    return prev;
                }, {});
            })
            .entries(data) // tell it what data to process
            .map(function (d) { // pull out only the values
                console.log("wides", d)
                return d.value;
            });

        // List of subgroups = header of the csv files = soil condition here
        var subgroups = [...new Set(data.map(obj => obj.dim2_name))]

        // List of groups = species here = value of the first column called dim1_name -> I show them on the X axis
        // var groups = d3.map(data, function(d){return(d.dim1_name)}).keys()
        var groups = [...new Set(data.map(obj => obj.dim1_name))]
        var lineData = []

        groups.forEach(g => {
            let sum=0;
            result[g].forEach(r=>{
                sum += r["metric1"]
                // console.log("loop r ",r,sum)
                result[g][0]['total']=sum
            })
            lineData.push(result[g][0])
        })

        console.log("Data", data, subgroups, groups, wide, lineData)
        // Add X axis
        var x = d3.scaleBand()
            .domain(groups)
            .range([0, width])
            .padding([0.2])
        svg.append("g")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom().scale(x).tickSizeOuter(0))
            .style('font-size', fontsize)
            .selectAll('text')
            .style('text-anchor', 'end')
            // .attr('dx', XaxisAttribute)
            .attr("dx", "-.8em")
            .attr("dy", ".15em")
            .attr('transform', 'rotate(-50)')
            .text(axisTextDim1);

        // Add Y axis
        var y = d3.scaleLinear()
            .domain([0, d3.max(lineData, function (d) {
                return +d.total;
            })])
            .range([height, 0]);
        svg.append("g")
            .call(d3.axisLeft(y).tickFormat(numberFormat))
            .style('font-size',fontsize);

        var unique = [...new Set(data.map(item => item.metric2))];
        if(unique.length>1){
            // Add Y2 axis
            var y2 = d3.scaleLinear()
                .domain([d3.min(lineData,function(d){
                    return +d.metric2;
                }), d3.max(lineData, function (d) {
                    return +d.metric2;
                })])
                .range([height, 0]);
            svg.append("g")
                .attr('transform', 'translate(' + (width) + ',0)')
                .call(d3.axisRight(y2).tickFormat(numberFormat))
                .style('font-size', fontsize);
        }


        // color palette = one color per dim2_name
        /*var schemeBlue = d3.schemeBlues[9];
        var schemeBlueRem1 = schemeBlue.filter(f=> {return f!== schemeBlue[0]});
        console.log("Blue white removed",d3.schemeBlues[9],schemeBlue, schemeBlueRem1);
        var color=d3.scaleOrdinal()
            .domain(subgroups)*/
        var color = d3.scaleOrdinal()
            .domain(subgroups)
            .range(["#D1EEEE", "#9ecae1", "#6baed6",'#7ca6e7', "#4292c6",'#345bd7', "#2171b5", "#08519c", "#08306b"])
        // .range(['#c7e9b4','#7ca6e7','#7fcdbb','#41b6c4', '#4986e7','#1d91c0','#225ea8','#253494','#345bd7','#0033CC','#081d58'])
        // .range(['#0033CC', '#345bd7', '#4986e7', '#7ca6e7'])

//stack the data? --> stack per dim2_name
        var stackedGen = d3.stack()
            .keys(subgroups)
        var stackedData = stackedGen(wide)
        console.log("StackedData", stackedData)


        d3.select("tooltip"+divId.id).remove(); // clear tooltip based on class of tip element
        // var div= d3.select(divId).append('div').attr('class', 'tooltip').attr('style', 'position: absolute; opacity: 0;');

        const tooltip = createTooltip(divId);

        // Show the bars
        svg.append("g")
            .selectAll("g")
            // Enter in the stack data = loop key per key = dim1_name per dim1_name
            .data(stackedData)
            .enter().append("g")
            .attr("fill", function (d) {
                return color(d.key);
            })
            .selectAll("rect")
            // enter a second time = loop subgroup per subgroup to add all rectangles
            .data(function (d) {
                return d;
            })
            .enter().append("rect")
            .attr("x", function (d) {
                return x(d.data.dim1_name);
            })
            .attr("y", function (d) {
                return y(d[1]);
            })
            .attr("height", function (d) {
                return y(d[0]) - y(d[1]);
            })
            .attr("width", x.bandwidth())
            .attr("stroke", "grey")
            .on('mouseover', function( d) {
                var subgroupName = d3.select(this.parentNode).datum().key;
                var subgroupValue = numberFormat(d.data[subgroupName]);
                var n = y(d[0]) - y(d[1]) > 25 ? (Math.round(100 * (d[1] - d[0]) / lineData.filter(l => l.dim1_name == d.data.dim1_name).map(l => l.total)[0])).toFixed(0) + '%' : '';
                console.log("tooltip data", d, data.filter(f => f.dim1_name == d.data.dim1_name).map(f => f.metric3)[0]);
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return chart.x1MetricTooltip + colonAnnotation + d.data.dim1_name + "<br>" +
                        chart.y1MetricTooltip + colonAnnotation + subgroupName + "<br>" +
                        chart.y2MetricTooltip + colonAnnotation + subgroupValue + " (" + n + ")";
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on('mouseout', function() {
                tooltip.onMouseLeave();  // Hide the tooltip on mouse leave
            })
            .on('contextmenu', function(d) {

            var subgroupName = d3.select(this.parentNode).datum().key;
            // Prepare clickedData with both axes' info
            const clickedData = {
                [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.data['dim1_name']],  // e.g., "2019", "2020"
                [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]: [subgroupName]               // e.g., "metric1"
            };
            // Generate the menu with current config and filters
            const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

            // Show the context menu
            contextMenu(menuItems).call(this, clickedData);

            // Prevent default context menu
            d3.event.preventDefault();
        });

        if(showValuesFlag){
            //Add value top of the each stacked bar
            svg.selectAll('text.bar')
                // Enter in the stack data = loop key per key = dim1_name per dim1_name
                .data(stackedData)
                .enter().append("g")
                .selectAll("rect")
                // enter a second time = loop subgroup per subgroup to add all rectangles
                .data(function (d) {
                    return d;
                })
                .enter()
                .append('text')
                .attr('class', 'bar')
                .attr('text-anchor', 'middle')
                .attr('x', (d)=> { console.log("bar height",y(d[0]) - y(d[1])); return x(d.data.dim1_name) + x.bandwidth() / 2 })
                .attr('y', (d)=> {return y((d[0]+d[1])/2) })
                // .text((d)=> {  return y(d[0]) - y(d[1]) >25 ? numberFormat(d[1]-d[0]) : '' }) //if the bar height is >25 then show the number
                .text((d) => {
                    return y(d[0]) - y(d[1]) > 25 ? (Math.round(100 * (d[1] - d[0]) / lineData.filter(l => l.dim1_name == d.data.dim1_name).map(l => l.total)[0])).toFixed(0) + '%' : '';
                })
                .attr('fill', 'DarkSlateGrey')
                // .attr('fill', 'DarkSlateGrey')
                .attr('fill', 'White')
                .style('font-size', fontsize)

        }

        //Add value top of the bar
        svg.selectAll('text.bartotal')
            .data(lineData)
            .enter()
            .append('text')
            .attr('class', 'bar')
            .attr('text-anchor', 'middle')
            .attr('x', (d)=> { return x(d.dim1_name) + x.bandwidth() / 2 })
            .attr('y', (d)=> {return y(d.total)-5 })
            .text((d)=> {  return numberFormat(d.total) })
            .attr('fill', 'black')
            .style('font-size', fontsize)

        // Axis Titles
        svg.append('text')
            .attr('x', (width / 2))
            .attr('y', chartHeight - chartMargin.top - 80)
            //.style('fill', 'blue')
            .style("text-anchor","middle")
            .style('fill', chart.axisFontColor)
            .style('font-size', fontlablesize)
            .text(chart.x1AxisDisplayName)
        // .text('dim1_name')

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chartMargin.left + 10)
            .attr('x', 0 - (height / 2))
            .attr("dy", ".71em")
            .style("text-anchor", "middle")
            .style('fill', chart.axisFontColor)
            .style('font-size', fontlablesize)
            .text(chart.y1AxisDisplayName)
        // .text('VAlue')

        // var unique = [...new Set(data.map(item => item.metric2))];
        if(unique.length>1){
            svg.append('text')
                .attr('transform', 'rotate(-90)')
                .attr('y',  width + chartMargin.right)
                .attr('x', 0 - (height / 2))
                .attr("dy", ".71em")
                .style("text-anchor", "middle")
                .style('fill', 'black')
                .style('font-size',fontlablesize)
                .text(chart.y2AxisDisplayName)
            // .text('metric2')

            // Draw the line
            svg
                .append("path")
                .attr("fill", "none")
                .attr("stroke", "#E3E01CFF")
                .attr("stroke-width", 1.9)
                .attr("d", function (d) {
                    console.log("line", d)
                    return d3.line()
                        .x(function (d) {
                            return x(d.dim1_name)  + x.bandwidth() / 2;
                        })
                        .y(function (d) {
                            return y2(d.metric2);
                        })(lineData)


                })

            svg.selectAll("dot")
                .data(lineData)
                .enter()
                .append("circle")
                .attr("r", 5)
                .attr("cx", d=>{ return x(d.dim1_name)  + x.bandwidth() / 2})
                .attr("cy", d=>{return  y2(d.metric2)})
                .style("fill", "blue")
                //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                .on('mouseover', function( d) {

                    tooltip.onMouseOver(d, this, function(d) {
                        // Tooltip content callback
                        return  chart.y2MetricTooltip + colonAnnotation+ numberFormat(d.metric2);
                    });  // Pass the event for positioning
                })
                .on('mousemove', function(event) {
                    tooltip.onMouseMove(event);  // Update tooltip position on mouse move
                })
                .on('mouseout', function() {
                    tooltip.onMouseLeave();  // Hide the tooltip on mouse leave
                })
                .on('contextmenu', function(d) {

                    // Prepare clickedData with both axes' info
                    const clickedData = {
                        [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name],  // e.g., "2019", "2020"
                    };
                    // Generate the menu with current config and filters
                    const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                    // Show the context menu
                    contextMenu(menuItems).call(this, clickedData);

                    // Prevent default context menu
                    d3.event.preventDefault();
                });


        }


        var legend = svg.selectAll(".legend")
            // .data(color.domain())
            .data(color.domain().slice().reverse())
            .enter()
            .append("g")
            .attr("class", "legend")
            .attr("transform", function (d, i) {
                return "translate(0," + i * 20 + ")";
            });

        var legendX = width + chartMargin.right + 20

        legend.append("rect")
            .attr("x", legendX)
            .attr("width", 15)
            .attr("height", 15)
            .style("fill", color);

        legend.append("text")
            .attr("x", legendX + 20)
            .attr("y", 9)
            .attr("dy", ".3em")
            .attr("class", "legend")
            .style("font-size", fontsize)
            .text(function (d) {
                return d
            });

    // })


}